import { useGraphQLClient } from 'providers';
import { useAccessToken, useUpdateAuthUser } from '../../index';
import { useQueryClient } from '@tanstack/react-query';

export const useUpdateCurrentUser = () => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();
  const { graphQLClient } = useGraphQLClient(accessToken);

  const queryInfo = useUpdateAuthUser(graphQLClient, {
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getCurrentUserData', {}] });
    },
  });

  return {
    ...queryInfo,
  };
};
